<template>
  <div class="cards-row" ref="parent" @resize="calculateCardsPerScreen">
    <div class="button-container">
      <button type="button" class="left arrow-button" v-if="scrollPos > 0" @click="scrollPos -= 1">
        <img :src="$assets.svg['triangle']" alt="" />
      </button>
    </div>

    <div class="scroller-container">
      <div class="scroller" ref="scroller" :style="scrollerStyles">
        <EventCard v-for="evEvent in evEvents" :key="evEvent.id" :evEvent="evEvent" :style="cardStyles" />
      </div>
    </div>

    <div class="button-container">
      <button type="button" class="right arrow-button" v-if="scrollPos < totalPositions - 1" @click="scrollPos += 1">
        <img :src="$assets.svg['triangle']" alt="" />
      </button>
    </div>
  </div>
</template>

<script>
import EventCard from '@/components/events/EventCard.vue';

export default {
  data() {
    return {
      scrollPos: 0,
      cardsPerScreen: 2,
    };
  },

  props: {
    evEvents: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    width() {
      return this.$refs.parent.clientWidth;
    },
    innerWidth() {
      const margin = 0.03 / this.cardsPerScreen;
      return `calc(${this.totalPositions}% * (100 / ${1 - margin}))`;
    },
    scrollerStyles() {
      return {
        width: this.innerWidth,
        left: this.leftPosition,
      };
    },
    cardStyles() {
      return {
        'margin-right': `calc(3% / ${this.totalPositions * this.cardsPerScreen})`,
        width: `calc(97% / ${this.totalPositions * this.cardsPerScreen})`,
      };
    },
    totalPositions() {
      return Math.ceil(this.numberOfCards / this.cardsPerScreen);
    },
    numberOfCards() {
      return this.evEvents.length;
    },
    leftPosition() {
      const margin = 0.03 / this.cardsPerScreen;
      const percent = `${100 / (1 - margin)}%`;
      return `calc(${this.scrollPos} * -${percent})`;
    },
    start() {
      return this.$refs.scroller.offsetLeft === 0;
    },
  },

  components: {
    EventCard,
  },

  mounted() {
    window.addEventListener('resize', this.calculateCardsPerScreen);
    this.calculateCardsPerScreen();
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.calculateCardsPerScreen);
  },

  methods: {
    calculateCardsPerScreen() {
      if (this.$refs.parent.clientWidth < 950) {
        this.cardsPerScreen = 1;
      } else if (this.$refs.parent.clientWidth < 1600) {
        this.cardsPerScreen = 2;
      } else {
        this.cardsPerScreen = 3;
      }
    },
  },
};
</script>

<style scoped>
.cards-row {
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
}

.scroller-container {
  overflow-x: hidden;
  width: 85%;
}

.scroller {
  position: relative;
  min-width: 85%;

  transition: 1s left ease;
}

.button-container {
  width: 7%;
  height: 135px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.arrow-button {
  width: 16px;
  height: 67px;
  padding: 0;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 11px;
  box-shadow: none;
  border: none;
}

.arrow-button > img {
  width: 75%;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  .arrow-button {
    width: 24px;
    height: 101px;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .arrow-button {
    width: 32px;
    height: 135px;
  }
}

.right.arrow-button > img {
  transform: scaleX(-1);
}
</style>
